import React from 'react';
import nv from './New folder/nv.png';
import { Button } from '@material-ui/core';
import TextField from '@mui/material/TextField';
import Footer from './footer';
import './about.css';
import {
  AiFillGoogleCircle,
  AiFillInstagram,
  AiFillYoutube,
  AiFillTwitterCircle,
  AiFillLinkedin,
} from 'react-icons/ai';
import { FaFacebook } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import swal from 'sweetalert';
import { URL } from './env';

export default function About() {
  let about = [
    {
      icon: <AiFillGoogleCircle />,
      name: 'Google',
      discription: 'In google',
      Links: 'www.g-news.com',
    },
    {
      icon: <AiFillInstagram />,
      name: 'Instagram',
      discription: 'In Instagram',
      Links: 'GujratNews',
    },
    {
      icon: <AiFillYoutube />,
      name: 'Youtube',
      discription: 'In Youtube',
      Links: 'Gujrat News',
    },
    {
      icon: <FaFacebook />,
      name: 'Facebook',
      discription: 'In Facebook',
      Links: 'GujratNews',
    },
    {
      icon: <AiFillTwitterCircle />,
      name: 'Twitter',
      discription: 'In Twitter',
      Links: 'GujratNews',
    },
    {
      icon: <AiFillLinkedin />,
      name: 'Linkdin',
      discription: 'In Linkdin',
      Links: 'GujratNews',
    },
  ];

  const [email, setEmail] = React.useState('');
  let navigate = useNavigate();
  let nameClick = (e) => {

    if (!email) {
      e.preventDefault()
      swal({
        title: 'Sorry',
        text: 'Please Insert Email',
        icon: 'warning',
        dangerMode: true,
      });
    }
    else {
      navigate('/About')
    }
  }
  return (
    <div>
      <div
        className="text-center pt-3"
        style={{
          display: 'flex',
          justifyContent: 'center',
          fontSize: '40px',
          color: 'rgb(54, 105, 217)',
          fontWeight: 'bold',
        }}
      >
        About Us
      </div>
      <section className="section">
        <div>
          <div className="row  d-flex align-items-center">
            <div className="col-md-6">
              <div>
                <img alt="Web Studio" src={nv} width="90%" />
              </div>
            </div>
            <div className="col-md-6 ml-auto">
              <div style={{ textAlign: 'left' }}>
                <h2
                  className="pb-3"
                  style={{
                    fontWeight: 'bold',
                    textAlign: 'center',
                    fontSize: '40px',
                    color: 'rgb(54 105 217)',
                  }}
                >
                  About Our Chanels
                </h2>
                <p className="margin-top-s">
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy text ever since the 1500s, when an unknown
                  printer took a galley of type and scrambled it to make a type
                  specimen book. It has survived not only five centuries, but
                  also the leap into electronic typesetting, remaining
                  essentially unchanged. It was popularised in the 1960s with
                  the release of Letraset sheets containing Lorem Ipsum
                  passages, and more recently with desktop publishing software
                  like Aldus PageMaker including versions of Lorem Ipsum.
                </p>
                <p className="margin-top-s">
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy text ever since the 1500s, when an unknown
                  printer took a galley .
                </p>
                <p className="margin-top-s">
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy text ever since the 1500s, when an unknown
                  printer took a galley of type and scrambled it to make a type
                  specimen book. It has survived not only five centuries, but
                  also the leap into electronic typesetting, remaining
                  essentially unchange.
                </p>
              </div>
              <div style={{ textAlign: 'left' }} className="mt-4">
                <form action={URL+"subscribe.php"} method="post">
                  <TextField
                  type='email'
                    required
                    name='subscribe'
                    id="outlined-textarea"
                    label="Subscribe"
                    placeholder="Placeholder"
                    size="small"
                    onChange={(e) => setEmail(e.target.value)}
                    value={email}

                  />
                  <Button
                    type='submit'
                    className="mx-4 pt-2"
                    variant="contained"
                    style={{ background: 'rgb(54 105 217)', color: 'white' }}
                    onClick={nameClick}
                  >
                    Submit
                  </Button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div>
        <div
          className="text-center"
          style={{
            fontWeight: 'bold',
            fontSize: '40px',
            color: 'rgb(54 105 217)',
          }}
        >
          Contact Us
        </div>

        <div className="container d-flex flex-wrap justify-content-center">
          {about.map((ele, i) => {
            return (
              <div key={i} className="box col-lg-4 col-md-4 col-sm-4 col-xs-12">
                <div className="box-part text-center">
                  <span className="fa pb-2">{ele.icon}</span>
                  <div className="title">
                    <h4>{ele.name}</h4>
                  </div>
                  <div className="text">
                    <span>
                      Lorem ipsum dolor sit amet, id quo eruditi eloquentiam.
                      Assum decore te sed. Elitr scripta ocurreret qui ad.
                    </span>
                  </div>
                  <div style={{ fontWeight: 'bold' }}>{ele.discription}</div>
                  <div className="text2">{ele.Links}</div>
                </div>
              </div>
            );
          })}
        </div>

        <div className="pt-4">
          <Footer />
        </div>
      </div>
    </div>
  );
}
